import { render, staticRenderFns } from "./receipt-template-form.vue?vue&type=template&id=fac1cb24&scoped=true"
import script from "./receipt-template-form.vue?vue&type=script&lang=ts"
export * from "./receipt-template-form.vue?vue&type=script&lang=ts"
import style0 from "./receipt-template-form.vue?vue&type=style&index=0&id=fac1cb24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fac1cb24",
  null
  
)

export default component.exports